export default {
    'Home': 'Главная',
    'Need_Funds_To ': 'Ваше участие в проектах',
    'We_Can_Chang_Many_Lives': 'МЫ МОЖЕМ ИЗМЕНИТЬ ЖИЗНЬ МНОГИХ ЛЮДЕЙ',
    'Home_Message': 'Здесь Вы можете внести свой вклад для всех,нуждающихся в Вашей помощи. В фонде мы публикуем проекты по прямой поддержке конкретных людей, семей, сообществ. Проекты, направленные на улучшение общественной среды нашего  региона, инфраструктурные, образовательные, культурные и спортивные. Деятельность фонда абсолютно прозрачна. Каждый может видеть все этапы реализации выбранного им проекта.',
    'Hello_User': 'Здравствуйте {user}',
    'Donate_Now': 'Пожертвовать сейчас!',
    'Spend_Monthly': 'Ежемесячные затраты',
    'Top_Donation': 'Наибольшие пожертвования',
    'Recent_Donation': 'Последние пожертвования',
    'Monthly_Organizations_Spend': 'Ежемесячные траты в адрес организаций',
    'Monthly_Project_Spend': 'Ежемесячные траты в адрес проектов',
    'View_All': 'Посмотреть все пожертвования',
    'Running_Projects': 'Текущие проекты',
    'Total_Received': 'Всего получено',
    'Total_Spend': 'Всего потрачено',
    'Contribute_Now': 'Внести вклад сейчас',
    'View_More': 'Смотреть ещё',
    'In_Queue_Projects': 'Проекты, следующие в очереди ',
    'Completed_Projects': 'Завершенные проекты',
    'Supporting_A_Good_Cause': 'НАЙТИ СВОЙ МОТИВ',
    'Good_Cause': 'Помогая нуждающимися, мы не становимся беднее. Вы можете выбрать подходящий проект и оказать ему свою поддержку.',
    'How_It_Works': 'Как это работает',
    'How_It_Work_Sub_Title': 'Мы помогаем собирать пожертвования для оказания нескольких различных видов помощи и поддержки.',
    'Start_Campaigns': 'Начало кампании',
    'Collect_Funds': 'Сбор средств',
    'Help_People': 'Помощь людям',
    'How_Info_1': 'Вначале комиссия из числа независимых попечителей, по итогам дискуссий, с учетом всех мнений и рекомендаций,  утверждает поступившие проекты в список одобренных. Получившие одобрение проекты публикуются на сайте фонда с полным их описанием и поэтапным планом реализации',
    'How_Info_2': 'Потенциальный пожертвователь имеет возможность выбрать на сайте наиболее понравившийся проект из списка всех незавершенных. Поступление средств отражается на сайте в режиме реального времени в разрезе проектов и пожертвователей. Информация прозрачна для всех пользователей сайта',
    'How_Info_3': 'Либо по мере накопления необходимой суммы, либо по мере поступления пожертвований на проект, средства расходуются непосредственно на реализацию проекта. Информация о состоянии проекта, о всех поступивших на проект средствах и всех затратах отражается на сайте для публичного просмотра',
    'About_Charity_Organizations': 'О Благотворительных Фондах',
    'About_Org_Info': 'Если Вам требуется поддержка для реализации социального проекта, или творческой идеи, или необходима персональная помощь - вы можете рассчитывать на нас, наших коллег и потенциальных доброжелателей.',
    'Thank_You_For_Supporting_Us': 'Спасибо за поддержку',
    'Footer_Info': 'Наша миссия заключается в улучшении среды обитания в нашем районе, раскрытии людского потенциала в области образования, спорта, культуры, общения, адресной помощи нуждающимся, заботе о подрастающем поколении',
    'Copy_Write_Info': 'Благотворительные фонды',
    'Terms_Of_Use': 'Условия',
    'Privacy_Policy': 'Конфиденциальность',
    'Support': 'Поддержка',
    'Share': 'Поделиться',
    'Projects': 'Проекты',
    'Organisation': 'Организации',
    'Fundraise_For': 'Сбор средств для',
    'Charity_Donators': 'Спонсоры благотворительности',
    'Home': 'Главная',
    'Total_Projects': 'Всего проектов',
    'Received_Amount': 'Получено средств',
    'Task_Force': 'Целевые усилия по глобальному здравоохранению',
    'Donate_Help': 'ВНЕСИТЕ СВОЙ ВКЛАД для ПОМОЩИ африканским детям в получении доступа к образованию',
    'Office': 'Office #429, Amanora Chambers, Hadapsar, Pune, Maharashtra',
    'Email': 'Электронная почта: info@enovate-it.com',
    'Charity_Trust': 'С 1988 года Благотворительный Фонд работает над тем, чтобы помочь детям осуществлять свои мечты. Мы, как организация, считаем, что дети не должны ущемляться в своих правах.',
    'Poblems_Of_Poverty': 'Мы видим, что проблемы бедности, неграмотности и бездомности особенно остро стоят перед детьми в семьях мигрантов. Эти семьи стараются обеспечить хотя бы базовый уход за детьми, их питание, не говоря уже о том, чтобы гарантировать образование. По нашему опыту, большинство родителей чувствуют себя беспомощными, испытывают чувство безнадежности, в то время как другие соглашаются на очень плохие варианты. Некоторые родители даже становятся жестокими и нетерпимыми по отношению к своим детям. Предоставляя этих детей самим себе и улице, они подвергают их опасности вовлечения в криминальную среду, опасности асоциального поведения, опасности отторжения от общества.',
    'All_Projects': 'Все проекты',
    'Total_Contribution_Amount': 'Общая сумма пожертвований',
    'Donation_Now': 'Пожертвовать сейчас',
    'Project_Activities': 'Реализации проекта',
    'Spent_Amount': 'Потрачено средств',
    'Bank_Details': 'Банковские реквизиты',
    'Bank_Name': 'Название банка',
    'Beneficiary_Name': 'Имя получателя',
    'BeneficiaryIBAN': 'Счет получателя (IBAN)',
    'Swift_BIC_Code': 'SWIFT/BIC код',
    'Organisation_Name': 'Наименование организации',
    'Payment_Ref': 'Номер платежа провайдера',
    'Ok': 'Ok',
    'Next': 'Далее',
    'User_Information': 'Информация о пользователе',
    'Your_Name': 'Ваше имя',
    'Donation_Amount': 'Сумма пожертвования',
    'Email_Id': 'Email Id',
    'Make_anonymous': 'Сделать мое пожертвование анонимным',
    'Back': 'Предыдущее',
    'Submit': 'Подтвердить',
    'Thank_You': 'Спасибо!',
    'Finish': 'Завершить',
    'Thank_You_info_1': 'СПАСИБО за пожертвование!',
    'Thank_You_info_2': 'Ваш подарок обязательно поможет изменить жизнь других людей в лучшую сторону.',
    'Thank_You_info_3': 'Письмо-подтверждение с данными о вашем пожертвовании будет отправлено на адрес электронной почты, который вы указали.',
    'Help_sharing': 'Помогите поделиться',
    'Copy': 'Копировать',
    'Close': 'Закрыть',
    'Search_Donator': 'Поиск донатора по имени, по названию проекта, по сумме оплаты и по платежному идентификатору провайдера ...',
    'Search_Projects': 'Поиск проектов...',
    'Project_name': 'Название проекта',
    'Running_Projects': 'Работающие проекты',
    'In_queue_Projects': 'В очереди проектов',
    'Completed_Projects': 'Завершенные проекты',
    'No_Projects_Available':'Нет Доступных Проектов!',
    'Completed_Projects':'Все завершённые проекты',
    'Payee_Name':'Получатель платежа',
    'Amount':'Сумма',

    'Reference_Id':'Ссылка',
    'Donation_Amount':'Сумма Доната',
    'Donation_Date':'Дата Доната',
    'User_Name':'Имя Пользователя',
    'Org_Proj':'Огранизация/Проект'

}